module.exports = __webpack_public_path__ + "img/preview_ppt.2595a2c5.png";